const {LinkedList} = require('./lib/collection/LinkedList');
const {TreeList} = require('./lib/collection/TreeList');
const {TreeSet} = require('./lib/collection/TreeSet');
const {Graph} = require('./lib/collection/Graph');

module.exports = {LinkedList, TreeList, TreeSet, Graph};